var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxtf-breadcrumb",
    _vm._l(_vm.list, function (item, index) {
      return _c(
        "yxtf-breadcrumb-item",
        {
          key: index,
          attrs: { "is-link": true },
          nativeOn: {
            click: function ($event) {
              return _vm.goUrl(item, index)
            },
          },
        },
        [_vm._v(_vm._s(item.name))]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }